module.exports = __webpack_public_path__ + "static/img/lp_example_02_m.ed0a80f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/lp_example_02_m.png
// module id = emeG
// module chunks = 3